import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import { Link } from 'react-router-dom';
import './tech.css';

import Html from "../../assets/images/Technology/Frontend/html5.png";
import Wordpress from "../../assets/images/Technology/Cms/wordpress.png";
import Shopify from "../../assets/images/Technology/Cms/shopify.png";
import Php from "../../assets/images/Technology/Backend/php.png";
import Laravel from "../../assets/images/Technology/laravel-img.png";
import Aiml from "../../assets/images/Technology/ai-ml-image.png";
import Flutter from "../../assets/images/Technology/Mobile/flutter.png";

import SEO from '../seo';

const Technologies = [
     {
        icon: Aiml,
        title: "AI/ML",
        desc: "In the rapidly evolving landscape of technology, the fusion of Artificial Intelligence (AI) and Machine Learning (ML)...",
        route: '/technology/ai-ml',

    },
    {
        icon: Flutter,
        title: "Flutter",
        desc: "In the ever-evolving landscape of technology, staying ahead is not just an advantage; it’s a necessity...",
        route: '/technology/flutter',

    },
    {
        icon: Html,
        title: "HTML/CSS",
        desc: "At Horizon Webinfo Pvt. Ltd. we believe in the power of innovation and seamless digital experiences...",
        route: '/technology/html-css',
        
    },
     {
        icon: Laravel,
        title: "Laravel/Codeigniter",
        desc: "At Horizon Webinfo Pvt. Ltd. we specialize in crafting robust and scalable web solutions using the powerful Laravel and CodeIgniter...",
        route: '/technology/laravel-codeigniter',

    },
      {
        icon: Php,
        title: "PHP/MYSQL",
        desc: "In the dynamic landscape of web development, choosing the right technologies is crucial for the ...",
        route: '/technology/php-mysql',
        
    },
     {
        icon: Shopify,
        title: "Shopify",
        desc: "At Horizon Webinfo Pvt. Ltd. we are dedicated to revolutionizing the digital landscape by providing cutting-edge Shopify..",
        route: '/technology/shopify',

    },
    {
        icon: Wordpress,
        title: "WordPress/Woocommerce",
        desc: "Welcome to the future of web development! In today’s fast-paced digital landscape, having a robust online prese..",
        route: '/technology/wordpress-woocommerce',

    },   
];


export default function Technology() {
       const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    return (
        <div>
              <SEO
                title="Technology"
                description="HTML/CSS At Horizon WebInfo Pvt Ltd, we believe in the power of innovation and seamless digital experiences&#8230; Our Services WordPress/Woocommerce Welcome to the future of web development! In today’s fast-paced digital landscape, having a robust online prese.. Our Services Shopify At Horizon WebInfo Pvt Ltd, we are dedicated to revolutionizing the digital landscape by providing [&hellip;]"
                canonical="https://www.hwplindia.com/technology/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/html5.png"
                keywords={pageKeywords}
            />

            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Technology</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Technology</li>
                    </ul>
                </div>
            </section>
            <section className="tech-wrapper">
                <div className="techno-container">
                    {Technologies.map((item, index) => (
                        <div className="tech-box" key={index}>
                            <img src={item.icon} alt={item.title} className="tech-icon" />
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                            <Link to={item.route}><button className="quote-btn tech-btn">READ MORE →</button></Link>
                        </div>
                    ))}
                </div>
            </section>

        </div>
    );
}